export const emptyReceipt = () => ({ recipientName: '', recipientPhone: '', shippingAddress: '' })
export function receiptPayload(value) {
  const result = Object.fromEntries(Object.keys(emptyReceipt()).map((key) => [key, String(value[key] || '').trim()]))
  const digits = result.recipientPhone.replace(/\D/g, '')
  if (!result.recipientName || result.recipientName.length > 100 || !result.shippingAddress || result.shippingAddress.length > 500 || result.recipientPhone.length > 30 || !/^[\d+ ()-]+$/.test(result.recipientPhone) || digits.length < 6 || digits.length > 20) {
    throw new Error('请填写完整收货资料及有效电话')
  }
  return result
}
export function displayTime(value) {
  return value > 0 ? new Date(value * 1000).toLocaleString('zh-CN', { hour12: false }) : '—'
}

// 申请和审核不代表礼金到账，沿用服务端订单状态。
export function prizeBonusProgress(order) {
  if (order?.prizeType !== 'BONUS') return ''
  return {
    PENDING_REVIEW: '申请已提交，审核通过后发放，当前尚未到账。',
    SUSPENDED: '申请审核已挂起，当前尚未到账，请查看审核结果。',
    REJECTED: '本次申请已驳回，未发放礼金。',
    PAID: '礼金已到账，可在资金记录查看入账明细。'
  }[order.status] || ''
}
